// Pagina gara, box "Proprietario della gara" (solo admin): ricerca tra race
// manager e admin, selezione e conferma prima di riassegnare races.id_user.
// Il markup è in race-details.blade.php e viene reso solo per gli admin.
require("sweetalert");

$(document).ready(function() {
	var $box = $(".race-owner");

	if (!$box.length) {
		return;
	}

	var $form = $box.find(".race-owner__form");
	var $toggle = $box.find(".race-owner__toggle");
	var $search = $form.find(".race-owner__search");
	var $options = $form.find(".race-owner__option");
	var $empty = $form.find(".race-owner__empty");
	var $submit = $form.find(".race-owner__submit");
	var $idUser = $form.find("input[name='id_user']");

	function openForm() {
		$form.prop("hidden", false);
		$toggle.attr("aria-expanded", "true").prop("hidden", true);
		$search.trigger("focus");
	}

	function closeForm() {
		$form.prop("hidden", true);
		$toggle.attr("aria-expanded", "false").prop("hidden", false);
		$search.val("");
		filter("");
		select(null);
	}

	function filter(query) {
		var words = query.toLowerCase().split(/\s+/).filter(Boolean);
		var visible = 0;

		$options.each(function() {
			var haystack = $(this).data("search");
			var match = words.every(function(word) {
				return haystack.indexOf(word) !== -1;
			});

			$(this).prop("hidden", !match).removeClass("is-active");
			if (match) {
				visible++;
			}
		});

		$empty.prop("hidden", visible > 0);
	}

	function select($option) {
		$options.attr("aria-selected", "false");

		if (!$option || $option.attr("aria-disabled") === "true") {
			$idUser.val("");
			$submit.prop("disabled", true);
			return;
		}

		$option.attr("aria-selected", "true");
		$idUser.val($option.data("id_user"));
		$submit.prop("disabled", false);
	}

	function moveActive(step) {
		var $visible = $options.not("[hidden]");
		var index = $visible.index($visible.filter(".is-active"));
		var next = Math.max(0, Math.min($visible.length - 1, index + step));

		$visible.removeClass("is-active");
		var $next = $visible.eq(next).addClass("is-active");

		if ($next.length) {
			$next[0].scrollIntoView({ block: "nearest" });
		}
	}

	$toggle.on("click", openForm);
	$box.find(".race-owner__cancel").on("click", closeForm);

	$search.on("input", function() {
		filter($(this).val());
	});

	$search.on("keydown", function(e) {
		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			e.preventDefault();
			moveActive(e.key === "ArrowDown" ? 1 : -1);
		} else if (e.key === "Enter") {
			// Invio seleziona l'opzione evidenziata, non invia il form
			e.preventDefault();
			var $active = $options.filter(".is-active").not("[hidden]");
			if ($active.length) {
				select($active);
			}
		} else if (e.key === "Escape") {
			closeForm();
		}
	});

	$options.on("click", function() {
		select($(this));
	});

	$form.on("submit", function(e) {
		e.preventDefault();

		var $selected = $options.filter("[aria-selected='true']");
		if (!$selected.length) {
			return;
		}

		var text =
			"La gara \"" + $form.data("race-title") + "\" passerà da " +
			$form.data("current-owner") + " a " + $selected.data("label") +
			".\n\nIl nuovo proprietario potrà gestirla dal pannello organizzatore, " +
			"il precedente non ne avrà più accesso (salvo collaborazioni).";

		swal({
			title: "Cambiare proprietario?",
			text: text,
			icon: "warning",
			buttons: ["Annulla", "Sì, assegna gara"],
			dangerMode: true
		}).then(function(confirmed) {
			if (confirmed) {
				$submit.prop("disabled", true);
				// submit nativo: non ripassa da questo handler
				$form[0].submit();
			}
		});
	});
});
